import { render } from "./NominationType.vue?vue&type=template&id=1c77d68d&scoped=true"
import script from "./NominationType.vue?vue&type=script&lang=js"
export * from "./NominationType.vue?vue&type=script&lang=js"

import "./NominationType.vue?vue&type=style&index=0&id=1c77d68d&lang=scss&scoped=true"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/movie-night/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c77d68d"]])

export default __exports__